import React, { useMemo } from 'react';

import { Control } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { colors } from 'constants-colors';
import { SwireAppEnum } from 'constants-whitelabel';

import { WhiteLabelType } from 'lane-shared/types/WhiteLabelType';

import { HookFormCheckBox } from '../../../../components/HookFormCheckBox';
import { useSwireApp } from 'react-hooks';

type ReducedWhiteLabel = Pick<
  WhiteLabelType,
  'termsAndConditionsUrls' | 'privacyPolicyUrls' | 'name' | 'url'
>;

type Props = {
  control: Control<any>;
  whitelabel: ReducedWhiteLabel;
};

export function SwireCommonTnC({ control, whitelabel }: Props) {
  const { t } = useTranslation();
  const { appType, termsAndConditionsUrl } = useSwireApp(whitelabel);
  const agreementLinks = useMemo(() => {
    const links: JSX.Element[] = [];

    links.push(createLink());

    return links;
  }, [whitelabel]);

  function createLink() {
    const linkText = t('web.onboarding.userProfile.termsAndConditionsLabel');
    const redirectUrl = termsAndConditionsUrl || '';

    return (
      <Link
        key={redirectUrl}
        data-test="link-to-parent"
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: 'underline', color: 'inherit' }}
        to={{ pathname: redirectUrl }}
      >
        {linkText}
      </Link>
    );
  }

  const tncAgreementKey = appType === SwireAppEnum.TAIKOO_PLACE && 'web.onboarding.userProfile.swire.taikooPlace.tncAgreement' || appType === SwireAppEnum.PACIFIC_PLACE_OFFICE && 'web.onboarding.userProfile.swire.pacificPlaceOffice.tncAgreement';

  if(!tncAgreementKey) {
    return null;
  }

  return (
    <HookFormCheckBox
      control={control}
      name="swire.commonTnC"
      data-test="onboarding-swire-common-tnc-checkbox"
      text={
        <div>
          <Trans
            i18nKey={tncAgreementKey}
            values={{ WhiteLabelName: whitelabel.name }}
            components={[agreementLinks[0]]}
          />
          <span style={{ color: colors.neutral.red7200, marginLeft: '0px' }}>*</span>
        </div>
      }
      isRequired
      labelStyles={{
        fontSize: '14px',
        fontWeight: 400,
        marginLeft: '10px',
      }}
    />
  );
}
